@if (show()) {
  <nav style="box-shadow: 0 2px 9px 3px rgba(0, 0, 0, 0.05)"
       class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-bg-white tw-border-t tw-border-solid tw-border-neutral-50 tw-z-50 md:tw-hidden tw-py-2">
    <div class="tw-flex tw-justify-evenly tw-items-center tw-h-16">

      @for (item of (isLandlord() ? landlordNavItems : tenantNavItems); track item.id) {
        <a
          class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-typography-label-sm tw-text-neutral-300"
          [routerLink]="item.id"
          routerLinkActive="!tw-text-main-primary"
          #rla="routerLinkActive"
          [routerLinkActiveOptions]="{ exact: false }">
          <mat-icon class="icon-size-24" [svgIcon]="item.icon"></mat-icon>
          {{ item.label }}
          <div class="tw-w-7 tw-h-1.5px tw-m-auto" [ngClass]="{'active-link-indicator': rla.isActive}"></div>
        </a>
      }
      <a
        class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1 tw-typography-label-sm tw-text-neutral-300"
        routerLink="/profile"
        routerLinkActive="!tw-text-main-primary"
        #menuRla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: false }">
        <mat-icon class="icon-size-24" svgIcon="list"></mat-icon>
        <ng-container i18n="@@ui-common.bottom-navbar.menu">Menu</ng-container>
        <div class="tw-w-7 tw-h-1.5px tw-m-auto" [ngClass]="{'active-link-indicator': menuRla.isActive}"></div>
      </a>
    </div>
  </nav>

}
